import React, { useState, useEffect, useRef } from 'react';
import { faFileAlt, faPencilAlt, faImage, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';
import Loading from '../../../components/Loading/Loading';
import ModalCustomized from '../../../components/Modal/Modal';

//Api
import vistoria_api from '../../../api/vistoria_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from 'context/auth';

export default function FichaVistoria({ btnVoltar, agendamentoId }) {
    const { session, setupVariavel } = useAuth();

    //Estado de controle dos dados da vistoria
    const [vistoria, setVistoria] = useState({});

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da foto da questão que foi selecionada
    const [foto, setFoto] = useState(null);

    //Referencia do relatorio
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Ficha de vistoria",
    });

    //Carrega os dados da vistoria
    useEffect(() => {
        setLoading(true);
        vistoria_api.GetItem(agendamentoId).then(response => {
            if (response.data.questoes) {
                response.data.questoes = response.data.questoes.map(value => {
                    if (value.tipoValor == "Data")
                        value.valor = moment(new Date(value.valor)).format("DD/MM/YYYY");

                    return value;
                })
            }
            if (response.data.cabecalhos) {
                response.data.cabecalhos = response.data.cabecalhos.map(value => {
                    if (value.tipoValor == "Data")
                        value.valor = moment(new Date(value.valor)).format("DD/MM/YYYY");

                    return value;
                })
            }

            setVistoria(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, []);


    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio} style={{ color: "#666" }}>
                {loading && <Loading />}
                <ModalCustomized
                    title={foto == null ? "" : foto.questao}
                    btnClose={true}
                    toggle={() => setFoto(null)}
                    isOpen={foto != null}
                >
                    <Col lg={"12"} className={"mb-3 mt-3 d-flex align-items-center justify-content-center"} style={{ cursor: "pointer" }} onClick={() => window.open(foto.caminho, "_blank")}>
                        <img src={foto == null ? "" : foto.caminho} width="400px" height="300px" />
                    </Col>
                </ModalCustomized>

                <div className="print d-flex align-items-center justify-content-between px-2">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-none imageHeader">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                    </div>
                }
                <div className="m-2 body">
                    <h2 className='fw-bold text-center my-3'>{vistoria?.identificacaoFormulario}</h2>
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Identificação da vistoria</span>
                    </h5>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Número da vistoria: </span> {vistoria?.id}</p>
                        </div>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Enquadramento: </span> {vistoria?.resultado}</p>
                        </div>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Identificação localidade: </span> {vistoria?.identificacaoLocalidade}</p>
                        </div>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Regional: </span> {vistoria?.regional}</p>
                        </div>
                        <div className='col-lg-12'>
                            <p><span className="fw-bold">Endereço da vistoria: </span> {vistoria?.endereco}</p>
                        </div>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Data/Hora Início: </span> {moment(new Date(vistoria?.dataHoraInicio)).format("DD/MM/YYYY HH:mm")}</p>
                        </div>
                        <div className='col-lg-6'>
                            <p><span className="fw-bold">Data/Hora Fim: </span> {moment(new Date(vistoria?.dataHoraFim)).format("DD/MM/YYYY HH:mm")}</p>
                        </div>

                    </div>

                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faImage} className={"me-3"} />Fotos do Local</span>
                    </h5>
                    <div className='m-3 d-flex align-items-center justify-content-center gap-2'>
                        {vistoria?.vistoriasFotos?.map((foto, index) => (
                            <div
                                key={index}
                                className='d-flex flex-column text-center'
                                style={{ cursor: "pointer" }}
                                onClick={() => window.open(foto.arquivo, "_blank")}
                            >
                                <img src={foto.arquivo} width={400} height={200} className='rounded' />
                                <span>{moment(foto.dataHora).format("DD/MM/YYYY HH:mm")}</span>
                            </div>
                        ))}
                    </div>

                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Cabeçalho</span>
                    </h5>
                    <Row>
                        {vistoria.cabecalhos && vistoria.cabecalhos.map(value => {
                            return (
                                <Col lg="6">
                                    <p><span className="fw-bold">{value.identificacao}: </span> {value.valor}</p>
                                </Col>
                            )
                        })}

                    </Row>

                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Perguntas </span>
                    </h5>
                    <div className='noPrint'>
                        <TabelaListagemFichas

                            headers={[
                                { value: "Pergunta", objectValue: "identificacao" },
                                { value: "Resposta", objectValue: "valor" },
                            ]}
                            items={vistoria.questoes ? vistoria.questoes : []}
                            conditionButton={(item, itemKey) => {
                                if (item.imagens) {
                                    return (
                                        <td className='text-center d-flex align-items-center justify-content-center' >
                                            <Button
                                                className={" d-flex align-items-center justify-content-center"}
                                                style={{ borderRadius: "100%", width: "35px", height: "35px" }}
                                                color='info text-light'
                                                onClick={() => setFoto({ questao: item.identificacao, caminho: item.imagens[0].imagem })}
                                                id={`btnRemover${itemKey}`}
                                            >
                                                <FontAwesomeIcon icon={faImage} />
                                            </Button>

                                        </td>
                                    )
                                } else {
                                    return <td></td>
                                }
                            }}
                            width={100}
                            scrollbar={false}
                        />
                    </div>

                    <div className='print'>
                        <TabelaListagemFichas
                            headers={[
                                { value: "Pergunta", objectValue: "identificacao" },
                                { value: "Resposta", objectValue: "valor" },
                            ]}
                            items={vistoria.questoes ? vistoria.questoes : []}
                            width={100}
                            scrollbar={false}
                        />
                    </div>


                    <div className='print flex-column avoid-break'>
                        {vistoria?.questoes?.map((questao, index) => (
                            <div key={index} className='w-100'>
                                <h5
                                    style={{ color: "#fff" }}
                                    className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                                >
                                    <span>
                                        <FontAwesomeIcon icon={faFileSignature} className={"me-3"} />
                                        Anexo {index + 1}
                                    </span>
                                </h5>


                                <div className='my-1 text-center'>
                                    {questao?.imagens != null && questao.imagens.map((image, indexfoto) => (
                                        <div key={indexfoto} className="d-inline-block text-center" style={{ width: '600px', height: '300px' }}>
                                            <img
                                                src={image.imagem}
                                                width="100%"
                                                height="auto"
                                                className="img-fluid"
                                                style={{
                                                    objectFit: 'cover',
                                                    display: 'block',
                                                    margin: '0 auto',
                                                    maxWidth: '400px',
                                                    height: 'auto'
                                                }}
                                            />
                                            <br />
                                            <span>Perguntar: {questao.identificacao}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>


                    <div className='avoid-break'>
                        <h5
                            style={{ color: "#fff" }}
                            className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                        >
                            <span><FontAwesomeIcon icon={faFileSignature} className={"me-3"} />Assinatura Digital </span>
                        </h5>
                        {vistoria?.assinatura &&
                            <div
                                className='mt-4 d-flex justify-content-center align-items-center'
                                style={{ cursor: "pointer" }}
                                onClick={() => window.open(vistoria?.assinatura, "_blank")}
                            >
                                <img
                                    src={vistoria?.assinatura}
                                    width={400}
                                    height={200}
                                />
                            </div>
                        }
                    </div>

                </div>
            </div>
        </MainCard>
    )
}